export const ENPOINT =
{
  url: '/portal_cloud_api/', 
  urlBase: '/',

  // url: "https://0507-2806-261-2402-9d80-50bb-a3f7-1e8-902b.ngrok.io/portal_cloud_api/",
  // url: 'https://proveedores-qas.bachoco.net/portal_cloud_api/', 
  // url: 'http://192.168.1.131:8085/portal_cloud_api/',
  // url: 'http://ebq.bachoco.net:8080/portal_cloud_api/',
  //  url: 'http://192.168.1.135:8080/portal_cloud_api/',
  //  url: 'http://189.135.156.188:8080/portal_cloud_api/',
  //  urlBase: 'http://ec2-54-218-201-71.us-west-2.compute.amazonaws.com:80/portal_cloud_api/',
  // url: 'http://ec2-54-218-201-71.us-west-2.compute.amazonaws.com:80/portal_cloud_api/',
  //  urlPort: 'http://ec2-54-218-201-71.us-west-2.compute.amazonaws.com:8180/',
  // url: 'http://ec2-54-218-201-71.us-west-2.compute.amazonaws.com:8180/portal_cloud_api/',
   urlAsistente : 'http://ec2-18-216-155-178.us-east-2.compute.amazonaws.com:3200/AsistenteF1/',
   client : 'Glouu',
   len : 'ES'
 
}; 

 

          


// WEBPACK FOOTER //
// ./src/app/services/endpoint.ts